







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import GradeService from '../services/grade-service';
import LabelService from '@/shared/services/label-service';
import HttpService from '@/shared/services/http-service';

import SelectStudy from './SelectStudy.vue';
import AcademicYears from './AcademicYears.vue'; 
import ModuleResults from './ModuleResults.vue';
import ExportDialog from './ExportDialog.vue';
import ExportCertifiedDialog from './ExportCertifiedDialog.vue';
import ExportConfirmationDialog from './ExportConfirmationDialog.vue';
import ExportButtons from './ExportButtons.vue';
import Loader from '@/shared/components/Loader.vue';
import MessageComponent from '@/shared/components/Message.vue';
import Popup from '@/shared/components/Popup.vue';
import GradeExportTooltip from './GradeExportTooltip.vue';

import { Config } from '../models/config-viewmodel';
import { Message } from '@/shared/models/view/message-viewmodel';

@Component({
    components: {
        SelectStudy,
        AcademicYears,
        Loader,
        MessageComponent,
        ModuleResults,
        ExportDialog,
        ExportCertifiedDialog,
        ExportConfirmationDialog,
        Popup,
        ExportButtons,
        GradeExportTooltip
    },
    computed: {
        ...mapState(['studies', 'config']),
        ...mapState('root', ['popupComponent']),
        ...mapGetters('root', ['label', 'labelHelp', 'message'])
    }
})
export default class GradesWidget extends Vue {
    @Prop() configRaw!: string;

    public config!: Config;
    public loading = true;
    private labelModule = 'ModuleOverview';

    mounted() {
        this.init();
    }

    private init() {
        this.setConfig();
    }

    private setConfig() {
        try {
            this.$store.commit('setConfig', this.configRaw);
            this.loadData();
        } catch(err) {
            this.$store.commit('root/setMessage', new Message('ModuleOverview', 'Er is iets fout gegaan bij het opstarten van het resultaten overzicht'));
            this.loading = false;
        }
    }

    private loadData() {
        Promise.all([
          GradeService.getAllStudies(this.config.language, this.config.vuNetIdStudent, HttpService),
            LabelService.getLabelsByCategory(this.config.language, this.labelModule, HttpService)
        ])
        .then(values => {
            this.$store.commit('setStudies', values[0]);
            this.$store.commit('root/setLabels', {labels: values[1], type: this.labelModule});
            this.loading = false;
        })
        .catch(error => {
            this.$store.commit('root/setMessage', new Message('ModuleOverview', 'Er is iets fout gegaan bij het ophalen van de resultaten: ' + error));
            this.loading = false;
        })
    }
}
